import styles from "./index.module.scss";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import Title from "@components/global/new/Title/Title";
import Button from "@components/global/new/Button/Button";
import cn from "classnames";
import { DeleteMinerError } from "@services/deleteMiner";
import { useIntl } from "react-intl";
import { serverErrors } from "../../../i18n/serverErrors.messages";
import Status from "../new/Status/Status";
import ServerErrorCodes from "@services/http/ServerErrorCodes";

interface MinersDeleteErrorModalPropsI {
  miners: DeleteMinerError[];
}

function MinersDeleteErrorModal(props: MinersDeleteErrorModalPropsI & CommonModalPropsI) {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.wrapper}>
      <Title className={styles.title}>
        {formatMessage({ id: "machines.actions.delete.error" })}
      </Title>

      <div className={styles.changesInfo}>
        <label>
        {formatMessage({ id: "machines.actions.delete.error.hint" })}
        </label>
        <div className={styles.table}>
          {props.miners && props.miners
              .map(
                (m) =>                  
                  <div className={styles.tableRow} key={m.id}>
                    <div className={cn(styles.tableCell, styles.tableRowName)}>
                      <div className={styles.cellContents}>
                        {m.miner_id}
                      </div>
                    </div>
                    <div className={cn(styles.tableCell, styles.tableRowValue)}>
                      <div className={styles.cellContents}>
                        <Status status={m.state}/>
                      </div>
                    </div>
                    <div className={cn(styles.tableCell, styles.tableRowValue)}>
                      <div className={styles.cellContents}>
                        {m.err_code as number === 0 ? serverErrors(ServerErrorCodes.MinerIsNotOffline) : serverErrors(m.err_code)}
                      </div>
                    </div>
                  </div>
              )}
        </div>
      </div>

      <div className={styles.btns}>
        <Button onClick={props.handleClose}>
          {"OK"}
        </Button>
      </div>
    </div>
  );
}

export default WithModal(
  MODALS_ENUM.MINERS_DELETE_ERROR_MODAL,
  MinersDeleteErrorModal,
  {
    style: {
      width: "500px",
    },
  }
);
